export default __webpack_public_path__ + "db6e54abe25fa174717e011cbf2fd661.svg";